module.exports = __webpack_public_path__ + "img/doc.105b8dab.png";